import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { RevertInstallationSecurityConfigurationResData } from "./RevertInstallationSecurityConfigurationResData";

const ENDPOINT = "/security/installation/configuration/revert";

export class RevertInstallationSecurityConfigurationCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: RevertInstallationSecurityConfigurationReqData = null;

    constructor(installationName: string, revertRolls: boolean) {
        super();
        this.params = new RevertInstallationSecurityConfigurationReqData(installationName, revertRolls);
    }

    public async execute(): Promise<RevertInstallationSecurityConfigurationResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new RevertInstallationSecurityConfigurationResData(res);
    }
}

export class RevertInstallationSecurityConfigurationReqData {
    installationName: string;
    revertRolls: boolean;

    constructor(installationName: string, revertRolls: boolean) {
        this.installationName = installationName;
        this.revertRolls = revertRolls;
    }
}
